import React from 'react';
import { FaCheck } from 'react-icons/fa';
import FormResponseAnswerValue from './FormResponseAnswerValue.js';

/** Shows a submission's workflow as a parcel-tracking style vertical timeline. */
export default function FormProcessTracker({ workflow, submissionId }) {
    const steps = Array.isArray(workflow?.steps) ? workflow.steps : [];
    if (!steps.length) return null;
    const timelineSteps = [{ stepId: 'initial-submission', name: 'Form submitted', status: 'complete', answers: [] }, ...steps];
    return <section className="forms-process-tracker" aria-label="Form progress">
        <h3>Progress</h3>
        <ol>{timelineSteps.map((step, index) => {
            const complete = step.status === 'complete';
            const current = step.status === 'current';
            return <li className={complete ? 'is-complete' : current ? 'is-current' : ''} key={step.stepId || index}>
                <span className="forms-process-marker" aria-hidden="true">{complete && <FaCheck />}</span>
                <div><strong>{step.name || `Step ${index + 1}`}</strong><small>{complete ? 'Complete' : current ? 'In progress' : 'Waiting'}</small>
                    {complete && Array.isArray(step.answers) && step.answers.length > 0 && <div className="forms-process-step-answers">{step.answers.map((answer, answerIndex) => <article key={answer.questionId || answerIndex}><b>{answer.label || `Question ${answerIndex + 1}`}</b><FormResponseAnswerValue answer={answer} submissionId={submissionId} /></article>)}</div>}
                </div>
            </li>;
        })}</ol>
    </section>;
}
